// extracted by mini-css-extract-plugin
export default {"brand-photos":"Brands_brand-photos__1zCAR","brand-photos-containers":"Brands_brand-photos-containers__f6p2m"};